import UserRegisterError from './UserRegisterError';

export default {
  path: 'rekisterointi-virhe',
  components: { content: UserRegisterError }
};
